import { ColumnMapping } from '../utils/types';

export const transformExcelRows = (data: string[][]) => {

  let maxColumnSize = 0;
  const mappedColumns = data.map((rowData: string[]) => {
    if (rowData.length > maxColumnSize) {
      maxColumnSize = rowData.length;
    }
    return rowData.reduce((acc, columnData: string, index) => {
      return {
        ...acc,
        [`column` + index]: columnData
      };
    }, {} as Record<string, string>);
  });
  return {
    maxColSize: maxColumnSize,
    mappedColumns
  };
};

export const fixMissingRows = (
  excelTransformedData: {
    maxColSize: number;
    mappedColumns: Record<string, string | boolean>[];
  },
  mappingColumnsLength: number
) => {
  if (excelTransformedData.maxColSize < mappingColumnsLength) {
    const nextExcelMappedColumns = excelTransformedData.mappedColumns.map(
      (rowElement) => {
        for (
          let i = Object.keys(rowElement).length;
          i < mappingColumnsLength;
          i++
        ) {
          rowElement = {
            ...rowElement,
            [`column` + i]: ''
          };
        }
        return rowElement;
      }
    );
    return {
      maxColSize: mappingColumnsLength,
      mappedColumns: nextExcelMappedColumns
    };
  }
  return excelTransformedData;
};

// Nueva función para agregar columnas especiales después de procesar el Excel
export const addSpecialColumns = (
  excelTransformedData: {
    maxColSize: number;
    mappedColumns: Record<string, string | boolean>[];
  },
  specialColumns: ColumnMapping[]
) => {
  const specialColumnCount = specialColumns.length;
  
  const updatedMappedColumns = excelTransformedData.mappedColumns.map((rowElement) => {
    const newRow = { ...rowElement } as Record<string, string | boolean>;
    
    // Agregar columnas especiales manteniendo la consistencia de índices
    specialColumns.forEach((specialColumn, index) => {
      // Usar el índice base + el índice de la columna especial
      const columnIndex = excelTransformedData.maxColSize + index;
      if (specialColumn.id === 'has_priority') {
        newRow[`column${columnIndex}`] = false; // Valor por defecto para hasPriority
      } else {
        newRow[`column${columnIndex}`] = '';
      }
    });
    
    return newRow;
  });
  
  return {
    maxColSize: excelTransformedData.maxColSize + specialColumnCount,
    mappedColumns: updatedMappedColumns
  };
};

// Nueva función para procesar el regreso antes del submit
export const processRegressDirections = (
  mappingData: Record<string, string | boolean>[]
): Record<string, string | boolean>[] => {
  return mappingData.map((row) => {
    const newRow = { ...row };
    
    // Buscar la columna with_regress
    const withRegressKey = Object.keys(row).find(key => 
      row[key] === true && key.includes('with_regress')
    );
    
    if (withRegressKey && row[withRegressKey] === true) {
      // Buscar la primera dirección
      const directionOneKey = Object.keys(row).find(key => 
        key.includes('direction_one')
      );
      
      if (directionOneKey && row[directionOneKey]) {
        // Duplicar la primera dirección como última
        const lastDirectionKey = Object.keys(row).find(key => 
          key.includes('direction_three')
        );
        
        if (lastDirectionKey) {
          newRow[lastDirectionKey] = row[directionOneKey];
        }
      }
    }
    
    return newRow;
  });
};
